var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.932,
    height: 41.411,
    viewBox: "0 0 232.932 41.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M95.483,107.527l8.985-15.594-5.085-8.808h7.643l5.086,8.808L103.1,107.527Z",
    transform: "translate(-64.329 -66.116)",
    fill: "#205214"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M86.809,107.527l9-15.583-5.091-8.818h7.643l5.091,8.818-9,15.583Z",
    transform: "translate(-65.423 -66.116)",
    fill: "#205214"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M76.818,107.28l-9-15.6,3.809-6.6,9.012,15.579H90.81l-3.821,6.619Z",
    transform: "translate(-67.818 -65.87)",
    fill: "#205214"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M81.149,99.761l-9-15.585,3.821-6.618,9,15.585H95.152l-3.821,6.619Z",
    transform: "translate(-67.271 -66.819)",
    fill: "#205214"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M76.529,76.829l5.085-8.808,17.975.006,3.809,6.6-17.962.015L80.351,83.45Z",
    transform: "translate(-66.719 -68.021)",
    fill: "#205214"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M80.871,84.35l5.091-8.818h17.959l3.821,6.619H89.784l-5.092,8.818Z",
    transform: "translate(-66.172 -67.074)",
    fill: "#205214"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M161.1,73.845,150.961,104.32H158.8l1.772-5.463h10.817l1.814,5.463h7.741L170.658,73.845Zm1.4,19.013,3.46-10.588,3.515,10.588Z",
    transform: "translate(-57.333 -67.287)",
    fill: "#205214"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 7.416,
    height: 30.474,
    transform: "translate(129.394 6.559)",
    fill: "#205214"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M220.69,79.738V73.845H196.8v6.562h13.927L196.116,98.345v5.975h24.762V97.757H205.954Z",
    transform: "translate(-51.639 -67.287)",
    fill: "#205214"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M232.328,91.727h11.129v-6H232.328v-5.32H246.4V73.845H224.911v30.474h21.613V97.757h-14.2Z",
    transform: "translate(-48.008 -67.287)",
    fill: "#205214"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M271.465,93.162a8.149,8.149,0,0,0,3.587-4.488c.055-.155.106-.322.154-.493.023-.078.047-.154.069-.234.009-.037.018-.078.028-.116a14.278,14.278,0,0,0,.411-3.544h0c.01-.339.017-.688.017-1.054,0-3.5-.756-5.888-2.309-7.311-1.527-1.4-4.109-2.079-7.894-2.079h-15.04V104.32H257.9V94.73h6.453l5.153,9.59h8.209ZM257.9,88.168V80.407h7.123c2.034,0,2.56.418,2.672.545s.53.793.53,3.262c0,2.338-.449,3.08-.643,3.29s-.833.663-2.936.663Z",
    transform: "translate(-44.783 -67.287)",
    fill: "#205214"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M149.919,73.774h-9.885L129.978,85.5V73.774h-7.959v30.554h7.959V94.914l3.253-3.424,8.216,12.838h9.885L138.622,85.8Z",
    transform: "translate(-60.983 -67.295)",
    fill: "#205214"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e26b3a8f11b5197d420a23631ddd1307.svg";
export { ForwardRef as ReactComponent };